<template>
	<v-card>
		<v-card-actions class="pa-3">
			<v-layout wrap>
				<v-flex xs12 sm6>
					<v-btn
						@click="attachFile"
						:class="{ success: hasFileAttached }"
						>{{ attachFileText }}</v-btn
					>
					<input
						:style="{ display: 'none' }"
						type="file"
						ref="file"
						@change="addImportFile"
					/>
				</v-flex>

				<v-spacer></v-spacer>

				<v-flex shrink>
					<v-btn
						@click="sendImport"
						:disabled="loading || !hasFileAttached"
					>
						<fa-icon
							:icon="['fas', 'cog']"
							spin
							size="lg"
							v-if="loading"
						/>

						<span v-else>Import</span>
					</v-btn>
				</v-flex>
			</v-layout>
		</v-card-actions>

		<v-card-actions class="pa-3" v-if="$slots['before-import']">
			<slot name="before-import"></slot>
		</v-card-actions>

		<v-card-actions class="pa-3" >
			<div v-if="templateUrl">
				<v-spacer></v-spacer>
				<v-btn :href="templateUrl" flat color="primary">
					<div class="v-icon v-icon--left">
						<fa-icon :icon="['far', 'download']" size="xs" />
					</div>
					{{ buttonText }}
				</v-btn>
			</div>

			<div v-if="exportUrl">
				<v-spacer></v-spacer>
				<v-btn :href="exportUrl" flat color="primary">
					<div class="v-icon v-icon--left">
						<fa-icon :icon="['far', 'download']" size="xs" />
					</div>
					{{ exportButtonText }}
				</v-btn>
			</div>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Errors from "@root/helpers/Errors";

export default {
	data() {
		return {
			importFile: [],
			loading: false,
			errors: new Errors(),
			attachFileText: "Choose file..."
		};
	},

	computed: {
		...mapGetters("admin", {
			PAGE: "usersPage"
		}),

		hasFileAttached() {
			return this.importFile instanceof File;
		}
	},

	props: {
		templateUrl: {
			default: false
		},

		importUrl: {
			type: String
		},

		fileName: {
			default: "file"
		},

		buttonText: {
			default: "Download Import Template"
		},

		exportUrl: {
			type: String
		},

		exportButtonText: {
			type: String,
			default: "Download Export"
		},

		onImported: {
			default: null
		}
	},

	methods: {
		...mapActions("admin", {
			SEND_IMPORT: "sendImport"
		}),

		addImportFile(value) {
			const file = value.target.files[0];

			this.importFile = file;
			this.attachFileText = file.name;
		},

		attachFile() {
			this.$refs.file.click();
		},

		sendImport() {
			this.loading = true;

			let formData = new FormData();

			formData.append(this.fileName, this.importFile);

			this.SEND_IMPORT({
				url: this.importUrl,
				formData
			})
				.then(data => {
					this.loading = false;
					this.importFile = [];

					this.$swal({
						title: "Import Complete",
						text: "Your import has completed successfully.",
						type: "success",
						confirmButtonText: "Okay"
					}).then(() => {
						if (this.onImported) {
							this.onImported();
						}
					});
				})
				.catch(error => {
					this.loading = false;
					this.importFile = [];

					error = Object.assign({}, error);
					this.errors.record(error.response.data.errors);

					let errorText = "There was a problem with the import.";

					if (typeof this.errors.errors !== "undefined") {
						if (this.errors.has(this.fileName)) {
							errorText = "Please choose a file to import.";
						} else {
							errorText = this.errors.errors;
						}
					}

					this.$swal({
						title: "Import Failed",
						text: errorText,
						type: "error",
						confirmButtonText: "Okay"
					});
				});
		}
	}
};
</script>
